<template>
    <div class="column flex-grow c-internal-notes"
        :data-component-name="$options.name"
    >
        <!-- <textarea v-if="projectInternalNotes && !$apollo.loading" v-model="projectInternalNotes.internal_notes" class="flex-grow c-internal-notes__text" @input="saveInternalNotes($event)">
        </textarea> -->
        <q-editor
            class="flex-grow c-internal-notes__text"
            flat
            toolbar-outline
            v-if="(value || value == '') && !$apollo.loading"
            v-model="value"
            :toolbar="[
                ['bold', 'italic', 'strike', 'underline'],
                ['hr']
            ]"
        >

        </q-editor>
        <div class="c-internal-notes__note text-right" v-if="value && !$apollo.loading" >
            * les notes internes ne sont pas publiées aux employés
        </div>
        <div class="text-center" v-if="$apollo.loading" >
            <q-spinner
                color="primary"
                size="1em"
            />
            Chargement en cours...
        </div>
    </div>
</template>

<script>
    // import {PROJECTINTERNALNOTES} from '@/graphql/project/queries'
    import {UPDATEPROJECTINTERNALNOTES} from '@/graphql/project/mutations'

    export default {
        name: 'ProjectInternalNotes',
        //components: { Component1, Component2 },
        props: {
            projectID: {
                type: [Number, String],
                default: null
            },
            internalNote: {
                type: String,
                default: ''
            }
        },
        data(){
        	return {
                saveTrottle: null,
                value: this.internalNote,
                updating: false
            }
        },
        mounted() {
            if(this.value==null) this.value = ''
        },
        //computed: {},
        watch: {
            // internalNote() {
            //     this.value = this.internalNote
            // },
            value() {
                this.$emit('internalnote:change', this.value)
            }
        },
        methods: {
            saveInternalNotes(){
                clearTimeout(this.saveTrottle)

                this.saveTrottle = setTimeout(function(){

                    this.updating=true;

                    this.$apollo.mutate({
                        mutation: UPDATEPROJECTINTERNALNOTES,
                        variables: {
                            projectID: this.projectID,
                            internalNote: this.internalNote
                        }
                    }).then(() => {
                        this.$q.notify({timeout: 500, type: 'positive', message: "Note interne sauvegardée"})

                    }).catch(e => {
                        if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                    })

                }.bind(this), 500)
            }
        },
        // apollo: {
        //     projectInternalNotes: {
        //         query: PROJECTINTERNALNOTES,
        //         fetchPolicy: 'cache-and-network',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
        //         //debounce: 200,
        //         error(error){
        //             if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
        //         },
        //         variables() {
        //             return {
        //                 projectID: this.projectID
        //             }
        //         },
        //         update(data) {
        //             if(data.projectInternalNotes?.internal_notes && !this.updating) this.internalNote = data.projectInternalNotes.internal_notes;
        //             this.updating=false;

        //             return data.projectInternalNotes
        //         },
        //     }
        // }
    }
</script>

<style lang="scss">
    .c-internal-notes {
        margin: 10px 25px;
        position: relative;

        & .q-editor {
            background-color: transparent;
            margin-bottom: 6px;

            &__content {
                // padding: 15px 0px;
                background-color: rgba($color: #ffffff, $alpha: 0.5);
                margin-top: 6px;
                flex-grow: 1;
                overflow-y: auto;

                position: absolute;
                bottom: 25px;
                top: 35px;
                left: 0px;
                right: 0px;
            }
        }

        &__note {
            font-size: 10px;
            color: $color-0;
        }
        &__text {
            // // padding: 25px;
            // border: none;
            background-color: transparent;
            font-size: 12px;
            display: flex;
            flex-direction: column;

            // border: none;
            // overflow: auto;
            // outline: none;

            // -webkit-box-shadow: none;
            // -moz-box-shadow: none;
            // box-shadow: none;
            // resize: none;
        }
    }
</style>